import { render, staticRenderFns } from "./AreaReports.vue?vue&type=template&id=0d7b06cc"
import script from "./AreaReports.vue?vue&type=script&lang=js"
export * from "./AreaReports.vue?vue&type=script&lang=js"
import style0 from "./AreaReports.vue?vue&type=style&index=0&id=0d7b06cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports